import { render, staticRenderFns } from "./SupplierRawMaterialPalmOilDerivatives.vue?vue&type=template&id=49a5431d&scoped=true&"
import script from "./SupplierRawMaterialPalmOilDerivatives.vue?vue&type=script&lang=js&"
export * from "./SupplierRawMaterialPalmOilDerivatives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a5431d",
  null
  
)

export default component.exports